namespace('arctic.views.gds');

compass.require('compass.hotel.StayRecapWidget');
compass.require('compass.hotel.PoliciesWidget');

compass.require('compass.demographic.GroupInfoWidget');
compass.require('compass.demographic.PasswordWidget');
compass.require('compass.demographic.CreditCardWidget');
compass.require('compass.group.GDSNamesWidget');

compass.requireLib('compass.util.tracking');
compass.requireLib('compass.util.parse');

arctic.views.gds.gdsGroupInfo = function (viewport, options) {
	// starts measuring the time it takes for the view to load
	compass.startLoad('gdsGroupInfoView');

	var me = this;
	var $j = jQuery;
	var d = jQuery.dom.getContext(this);
	var _viewport = viewport;

	var _widgets = {};
	var _recapWidget;
	var _paymentType = 'charge'; // TODO figure me out
	var _settings = options;

	var _invalid_fields = [];
	var _bubble = null;
	var _validator = new compass.validator({
		widget: me,
		onValid: function (field, opts) {
			field.removeClass("invalid");
			if (_bubble !== null) {
				_bubble.remove();
				_bubble = null;
			}
			_checkWholeForm();
		},
		onInvalid: function (field, opts) {
			field.addClass("invalid");
		}
	});

	var CC_CHARGE_HEADER = 'We need a credit card to hold your room.  NOTE: Your credit card will be charged a guarantee for this room at the time of booking.  Please review the hotel policies for additional information.';
	var CC_DEPOSIT_HEADER = 'We need a credit card to hold your room.  Please review the hotel policies for additional information regarding when your card may be charged.';

	var _render = function () {
		_viewport.append(d.div({ className : 'groupInfo' },
			d.div({ className : 'reservationRecap' }),
			d.div({ className : 'separator'}),
			d.div({ className : "forms" },
				d.div({ className : 'groupInfoHeader'},
					d.div({ className : 'groupInfoTitle'}, 'Group Reservation')
				),
				d.div({className : 'groupInfoInstruction'},
					"Start by entering the group's main contact info and you'll have the option to enter guest details and other preferences for each room in just a moment."
				),
				d.div({ className : 'groupInfoMain' }),
				d.div({ className : 'passwordInfo' }),
				d.div({ className : 'paymentHeader' },
					d.div({ className : 'paymentTitle'}, 'Group Payment Guarantee')
				),
				d.div({ className : 'creditCardTitle demographicTitle' }, _paymentType === 'charge' ? CC_CHARGE_HEADER : CC_DEPOSIT_HEADER),
				d.div({ className : 'creditCard' }),
				d.div({ className: 'groupNamesMain' },
					d.div({ className: 'groupNamesHeader' }, "Group Names"),
					d.div({ className: 'groupNamesInstruction' }, "Web Rate bookings require names in order to complete and confirm your reservations.  Please submit names below to finalize your hotel reservations.")
				),
				d.separator(),
				d.div({className : 'policiesAgreeDiv'},
					d.input({className : 'policiesCheckbox',
						type: 'checkbox',
						value:'true'}),
					d.div({className :'policiesTextDiv'}, 'I agree to the'),
					d.a({ className:'policiesLink'}, 'hotel policies'),
					d.div({ className : 'clear'})
				),

				d.input({ className : 'saveButton button',
					type : 'submit',
					value : 'Save'})
			),
			d.div({ className : 'stayRecap' })
		));
	};

	var _setup = function (data) {
		_widgets.groupInfo = new compass.demographic.GroupInfoWidget(_viewport.find('.groupInfoMain'), {
			label: 'Company/Group Name',
			validator: _validator,
			prefill: data.groupInfo,
			editablePrefill: _settings.regData
		});
		if (!data.groupInfo) {
			_widgets.password = new compass.demographic.PasswordWidget(_viewport.find('.passwordInfo'), {
				validator: _validator
			});
		}
		_widgets.payment = new compass.demographic.CreditCardWidget(_viewport.find('.creditCard'), {
			addressWidget: _settings.countriesAndStates,
			validator: _validator,
			creditCardTypes: data.paymentOptions.payMethods,
			displayCVC: data.paymentOptions.store_cvc,
			//currentPayment : (data.groupInfo && data.groupInfo.payments && data.groupInfo.payments.length > 0 )  ? data.groupInfo.payments[0] : false,
			//storedCards: (data.groupInfo && data.groupInfo.payments) ? data.groupInfo.payments.length > 0 : false,
			minExpiration: compass.util.parse.ISODateParser(_settings.meetingInfo.ends),
			maskCCNumber : _.contains(data.extraRequiredFields, 'maskCreditCard')
		});
		_widgets.names = new compass.group.GDSNamesWidget(_viewport.find('.groupNamesMain'), {
			number: parseInt(data.reservations[0].summary.numRooms, 10),
			validator: _validator
		});

		_recapWidget = new compass.hotel.StayRecapWidget(_viewport.find('.stayRecap'), {
			recapArray: _.map(data.reservations, function (res) { return res.summary; }),
			meetingInfo: _settings.meetingInfo,
			GDS: true
		});

		_validator.addFields(_viewport.find('.policiesCheckbox'), function (policiesCheckbox) {
			return policiesCheckbox.prop('checked') ? _validator.VALID: _validator.INVALID;
		});

		_recapWidget.bind('StayRecapWidget.showPolicies', function () { _showPoliciesPopup(data); });
		_viewport.find('.policiesLink').activate(function () { _showPoliciesPopup(data); });

		_viewport.find(".saveButton").activate(sendInfo);

		_viewport.find('.policiesCheckbox').change(function() {
			if ($(this).is(':checked')) {
				$('.alertCloseButton').activate();
			}
		});		
	};

	var _showPoliciesPopup = function (data) {
		var policiesDiv = d.div({className:'policiesContainer'});

		_policiesWidget = new compass.hotel.PoliciesWidget(policiesDiv, {
			policies: {
				policies: {
					"depositPolicy": data.reservations[0].GDSInfo.GDSDepositPolicy,
					"cancelPolicy": data.reservations[0].GDSInfo.GDSCancelPolicy,
					"changesPolicy": "",
					"specialPolicy": "",
					"roomName": data.reservations[0].summary.roomType,
					"hotelName": data.reservations[0].summary.hotelName
				}
			}
		});

		_policiesDialog = d.dialog({
			classes: 'personalInfo policiesDialog',
			contents: policiesDiv,
			centerOnView: true
		});
	};

	var sendInfo = function (event) {
		var d = jQuery.dom;
		var button = _viewport.find('.saveButton');
		var data = {};

		if(button.hasClass('disabled')) { return; }
		button.addClass('disabled');

		data.policiesCheckbox = $j('.policiesCheckbox').prop('checked');
		if(data.policiesCheckbox === false){
			_policiesAgreeDialog = d.alert('Please agree to the hotel policies before continuing');
		}

		$j('body').css({cursor : 'wait'});

		_.each(_invalid_fields, function (node) {
			node.unbind('focus.hint')
				.unbind('change.hint')
				.unbind('blur.hint')
				.removeClass('invalid');
			});

		_invalid_fields = _validator.validate();

		// Validate me!
		if (_invalid_fields.length > 0) {
			$j('body').css('cursor', 'default');
			_.each(_invalid_fields, function (node) {
				node.bind('focus.hint', function (event) {
					var me = $(this);
					if (me.data("valid") === _validator.VALID) { return; }

					if (jQuery.isArray(me.data("hint"))) {
						var errorText = me.data("errorIndex") >= 0 ? me.data("hint")[me.data("errorIndex")] : me.data("hint")[0];
					} else {
						var errorText = me.data("hint");
					}

					_bubble = d.div({
						className: 'reqHint'
					}, d.div({
						className: 'triangle'
					}), d.div({
						className: 'text'
					}, errorText)
					);
					_bubble.insertAfter(me);
					_bubble.css("margin-left", (me.outerWidth(true) - _bubble.outerWidth(true))/2);
					if (me.css("float") !== "none") {
						_bubble.css("margin-top", me.outerHeight(true));
					}
				}).bind('change.hint', function (event) {
					if (_bubble !== null) {
						_bubble.remove();
						_bubble = null;
					}
				}).bind('blur.hint', function (event) {
					if (_bubble !== null) {
						_bubble.remove();
						_bubble = null;
					}
				}).addClass("invalid");

				if (node.is("select")) {
					node.one('focus', function (event) {
						var $this = $(this);
						var temp = _bubble;
						_bubble = null;
						$this.blur();
						_bubble = temp;
					});
				}
			});
			_invalid_fields[0].focus();
			return;
		}

		data.contact = _widgets.groupInfo.grabValues();
		data.payment = _widgets.payment.grabValues();
		if (_widgets.password) {
			data.password = _widgets.password.grabValues();
		}
		data.names = _widgets.names.grabValues();

		$j.ajax({
			url: "/actGDSGroupInfo",
			data : JSON.stringify(data),
			type : 'POST',
			contentType : 'application/json',
			processData: false,
			error: function (data) {
				button.prop("disabled", false);
				// handle data for various failure conditions
			},
			success: function (data) {
				jQuery.ajax({
				url : '/sendConfirmation',
					success : function(data) {
						compass.util.tracking.exactTargetConversion();
						compass.util.tracking.googleConversion();
					}
				});				
				$j('body').css({cursor : 'inherit'});
				$j('body').trigger(CompassEvents.Login, data.loginInfo);
				_viewport.trigger(CompassEvents.Navigate, 'frontDesk');
			}
		});
	};

	var _checkWholeForm = function() {
		_validation_res = _validator.validate();

		if (_validation_res.length === 0) {
			var button = _viewport.find(".saveButton");
			button.removeClass('disabled');
		}
	};

	this.run = function (renderComplete) {
		compass.loading.start();

		$j.ajax({
			url: '/getGDSGroupInfo',
			success: function (data) {
				_jsonData = data;
                _settings.countriesAndStates = data.countriesAndStates;
				if (data.error) {
					_viewport.trigger(CompassEvents.Navigate, 'frontdesk');
				} else {
					_render();
					_setup(data);
				}
				compass.loading.stop();
				// stops measuring the time it takes the view to load
				compass.stopLoad('gdsGroupInfoView');
				renderComplete();
			}
		});
	};
};
